/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profile_Editors_FloatingInputs */

const en_us2_profile_editors_floating = /** @type {(inputs: Profile_Editors_FloatingInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`No set day:`);
	return /** @type {LocalizedString} */ (`${i?.count} with no set day:`)
	
};

const pt_br2_profile_editors_floating = /** @type {(inputs: Profile_Editors_FloatingInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Sem dia marcado:`);
	return /** @type {LocalizedString} */ (`${i?.count} sem dia marcado:`)
	
};

const es_419_profile_editors_floating = /** @type {(inputs: Profile_Editors_FloatingInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Sin día fijo:`);
	return /** @type {LocalizedString} */ (`${i?.count} sin día fijo:`)
	
};

const pt_pt2_profile_editors_floating = /** @type {(inputs: Profile_Editors_FloatingInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Sem dia marcado:`);
	return /** @type {LocalizedString} */ (`${i?.count} sem dia marcado:`)
	
};

const fr_fr2_profile_editors_floating = /** @type {(inputs: Profile_Editors_FloatingInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Sans jour fixé :`);
	return /** @type {LocalizedString} */ (`${i?.count} sans jour fixé :`)
	
};

const de_de2_profile_editors_floating = /** @type {(inputs: Profile_Editors_FloatingInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Ohne festen Tag:`);
	return /** @type {LocalizedString} */ (`${i?.count} ohne festen Tag:`)
	
};

const it_it2_profile_editors_floating = /** @type {(inputs: Profile_Editors_FloatingInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Senza giorno fisso:`);
	return /** @type {LocalizedString} */ (`${i?.count} senza giorno fisso:`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "No set day:" |
* | * | "{count} with no set day:" |
*
* @param {Profile_Editors_FloatingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_floating = /** @type {((inputs: Profile_Editors_FloatingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_FloatingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_floating(inputs)
	if (locale === "es-419") return es_419_profile_editors_floating(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_floating(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_floating(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_floating(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_floating(inputs)
	return en_us2_profile_editors_floating(inputs)
});
export { profile_editors_floating as "profile-editors.floating" }